export const NAV = {
  logo: "nav-logo",
  link: (id) => `nav-link-${id}`,
  ctaDemo: "nav-cta-demo",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  badge: "hero-badge",
  title: "hero-title",
  subtitle: "hero-subtitle",
  ctaDemo: "hero-cta-demo",
  ctaContact: "hero-cta-contact",
  statsCard: (id) => `hero-stat-${id}`,
};

export const SERVICES = {
  section: "services-section",
  card: (id) => `service-card-${id}`,
};

export const FEATURES = {
  section: "features-section",
  row: (id) => `feature-row-${id}`,
};

export const STEPS = {
  section: "how-it-works-section",
  step: (id) => `how-step-${id}`,
};

export const BENEFITS = {
  section: "benefits-section",
  card: (id) => `benefit-card-${id}`,
};

export const AUDIENCE = {
  section: "audience-section",
  card: (id) => `audience-card-${id}`,
};

export const TESTIMONIALS = {
  section: "testimonials-section",
  prev: "testimonials-prev",
  next: "testimonials-next",
  card: (id) => `testimonial-card-${id}`,
};

export const CTA = {
  section: "cta-section",
  bookDemo: "cta-book-demo",
  contactSales: "cta-contact-sales",
};

export const FOOTER = {
  section: "footer-section",
  link: (id) => `footer-link-${id}`,
};
